module.exports = __webpack_public_path__ + "static/media/icon-pagamento.4a6b60b0.svg";